module.exports = __webpack_public_path__ + "img/home-cases-5.b4ef4987.png";